export default class FastJobDialogs {
  constructor(number) {
    this.dialogFastJob = false;
    this.fastJobDialogVoiceNumber = number;
  }
}
